import React from 'react'

export default function General() {
  return (
    <div>General</div>
  )
}
